import React from "react";
import { useParams } from "react-router-dom";
import { SCHOOL_FACILITIES } from "../../constants";
import SeoContent from "../../components/shared/SeoContent";

export default function FacilityFullDetail() {
  const { slug } = useParams();
  const facility = SCHOOL_FACILITIES.find((f) => f.slug === slug);

  if (!facility) {
    return (
      <div className="p-10 text-center text-red-600">Facility not found.</div>
    );
  }

  return (
    <>
      <SeoContent title={facility.title} />

      {/* Hero Section */}
      <section className="relative w-full h-[450px]">
        <img
          src={facility.images[0]}
          alt={facility.title}
          className="w-full h-full object-cover brightness-75"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">
            {facility.title}
          </h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="px-4 py-12 max-w-6xl mx-auto">
        <div className="mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
            About the {facility.title}
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            {facility.descriptions || "Explore the key highlights and offerings of our facility."}
          </p>
        </div>

        <div className="space-y-10">
         
          
            <p  className="text-lg text-gray-700 leading-relaxed">
              {facility.descriptions}
            </p>
          
        </div>

        {/* Gallery Section */}
        {facility.images.length > 1 && (
          <div className="mt-16">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Gallery</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {facility.images.slice(1).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`Gallery ${idx + 1}`}
                  className="rounded-xl h-64 object-cover w-full shadow"
                />
              ))}
            </div>
          </div>
        )}
      </section>
    </>
  );
}
